// src/utils/request.js
import axios from 'axios';

const baseUrl = "https://zetuan.dadayc.com";
// const baseUrl = "http://127.0.0.1:7078";

// 创建axios实例
const service = axios.create({
    baseURL: baseUrl, // 接口基准地址（可在.env文件配置）
    timeout: 10000, // 请求超时时间
    headers: {
        'Content-Type': 'application/json;charset=utf-8'
    }
});

// 请求拦截器：添加token等通用配置
service.interceptors.request.use(
    (config) => {
        // 示例：如果有登录token，添加到请求头
        // const token = localStorage.getItem('token');
        // if (token) {
        //   config.headers.Authorization = `Bearer ${token}`;
        // }
        return config;
    },
    (error) => {
        console.error('请求错误：', error);
        return Promise.reject(error);
    }
);

// 响应拦截器：统一处理返回结果和异常
service.interceptors.response.use(
    (response) => {
        const res = response.data;
        // 假设后端返回格式：{ code: 200, data: {}, msg: '成功' }
        if (res.code !== "000000") {
            // 非200状态码统一提示
            console.error('接口返回错误：', res.msg || '请求失败');
            return Promise.reject(new Error(res.msg || '请求失败'));
        } else {
            return res.data; // 直接返回业务数据，简化页面调用
        }
    },
    (error) => {
        console.error('响应错误：', error.message);
        // 网络错误/超时等统一提示
        let errorMsg = '网络异常，请稍后重试';
        if (error.code === 'ECONNABORTED') {
            errorMsg = '请求超时，请稍后重试';
        }
        return Promise.reject(new Error(errorMsg));
    }
);

export default service;
